import styled from "styled-components";
const Nav = styled.ul`
  display: flex;
  align-items: center;

  margin: 0;
  padding-left: 0;

  > li {
    flex-shrink: 0;
  }
`;
export default Nav;
